import { css } from '@emotion/core';
import helperUtils from '../table/utils/helper.util';

export default ({ contentBeforeInput, readOnly, required, width }) => ({
  containerStyles: css`
    ${width
      ? `width: 100%;`
      : `max-width: max-content; max-width: -moz-max-content;`}
    ${helperUtils.checkBrowser('ie') ? 'display: inline-block;' : ''}

      label{
        word-break: break-word;
      }
    
  `,
  inputStyles: ({ cybs, vds }) => css`
    width: 100%;
    ${readOnly ? '& input { pointer-events: none; }' : ''}

    ${contentBeforeInput
      ? `
        .contentBeforeInput {
          margin: 4px;
          display: flex;
        }
        &.vds-input .vds-input-hint {
          top: 0px;
          left: 36px;
        }
        &.vds-input .vds-icon use {
          fill: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};
        }
      `
      : ''}

    &.vds-input {
      min-width: auto;
      margin-top: 0px;
      ${width.toString().indexOf('%') > -1 ? '' : 'width: min-content;' }

      & .vds-input-message {
        align-items: flex-start !important;

        & svg {
          margin-top: 0.125rem !important;
          min-width: 1em;
        }
      }

      & .vds-input-bar {
        margin-bottom: 4px;
      }
    }

    .vds-input--input-text {
      ::placeholder {
        color: ${cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};
      }
    }

    /* Label color - focus */
    &.vds-input.vds-state--focus:not(.vds-state--readonly)
      .vds-input-label:nth-of-type(1),
    &.vds-input.vds-state--focus:not(.vds-state--error)
      .vds-input-label:nth-of-type(1),
    &.vds-input.vds-state--focus.vds-state--filled:not(.vds-state--error)
      .vds-input-label:nth-of-type(1),
    &.vds-input.vds-state--focus:not(.vds-state--disabled)
      .vds-input-label:nth-of-type(1) {
      color: ${cybs?.core?.primary ?? '#1434CB'}!important;
    }


    /* Label color - hover */
    &.vds-input.vds-state--focus:not(.vds-state--readonly)
      .vds-input-label:nth-of-type(1),
    &.vds-input.vds-state--focus:not(.vds-state--disabled)
      .vds-input-label:nth-of-type(1) {
      color: ${cybs?.core?.primary ?? '#1434CB'};
    }

    /* Label color - focus (textarea) */
    &.vds-input-textarea-container.vds-state--focus:not(.vds-state--readonly)
      .vds-input-label:nth-of-type(1),
    &.vds-input-textarea-container.vds-state--focus:not(.vds-state--disabled)
      .vds-input-label:nth-of-type(1) {
      color: ${cybs?.core?.primary ?? '#1434CB'};
    }

    /* Label color - disabled */
    &.vds-input.vds-state--disabled,
    &.vds-input.vds-state--disabled.vds-state--filled
      .vds-input-label:nth-of-type(1) {
        label {
          color: ${cybs?.base?.wcag21?.disabledGrey ?? '#00000033'} !important;
          position: static !important;
          font-size: 0.875rem !important;
        }
    }

    /* Text color - read only */
    &.vds-input.vds-state--readonly:not(.vds-state--disabled)
      .vds-input--input-text,
    &.vds-input.vds-state--readonly.vds-state--filled:not(.vds-state--disabled)
      .vds-input--input-text {
      color: ${cybs?.base?.wcag21?.charcoal ?? "#000000"};
      ::placeholder {
        color: ${cybs?.base?.wcag21?.charcoal ?? "#000000"};
      }
    }

    /* Text color - disabled */
    &.vds-input.vds-state--disabled .vds-input--input-text {
      color: ${cybs?.base?.wcag21?.disabledGrey ?? '#00000033'} !important;
      ::placeholder {
        color: ${cybs?.base?.wcag21?.disabledGrey ?? '#00000033'};
      }
    }

    /* Icon color - disabled */
    &.vds-input.vds-state--disabled [class^='vds-icon'] use,
    &.vds-input.vds-state--disabled.vds-state--filled [class^='vds-icon'] use {
      fill: ${cybs?.base?.wcag21?.disabledGrey ?? '#00000033'};
    }

    &.vds-input.vds-state--disabled [class^='vds-icon'],
    &.vds-input.vds-state--disabled.vds-state--filled [class^='vds-icon'] {
      height: 24px;
      width: 24px;
    }

    /* Icon color - readonly */
    &.vds-input.vds-state--readonly [class^='vds-icon'] use,
    &.vds-input.vds-state--readonly.vds-state--filled [class^='vds-icon'] use {
      fill: ${cybs?.base?.wcag21?.disabledGrey ?? '#00000033'};
    }

    & .vds-input-hint {
      top: auto;
      color: ${cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};
    }
    
    &.vds-input.vds-state--readonly,
    &.vds-input.vds-state--disabled,
    &.vds-input.vds-state--disabled.vds-state--filled,
    &.vds-input.vds-state--readonly.vds-state--filled {
      .vds-input-bar {
        border-color: ${cybs?.base?.wcag21?.disabledGrey ?? '#00000033'} !important;
      }
    }
  
    & .vds-input-bar {
      background-color: white;
      width: ${width} !important;
      max-width: 100%;
      min-height: 2.5rem;
      align-items: center;
      border-color: ${vds?.miscExtraDark ?? '#000000'};

      & .vds-input--textarea {
        min-height: 2.5rem;
        width: 100%;
      }
    }

    &.vds-input.vds-state--filled,
    &.vds-input-textarea-container.vds-state--filled:not(:hover){
      .vds-input-label {
        color: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};
      }
      .vds-input-bar {
        border-color: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};
      }
    }
    
    &.vds-input-label {
            pointer-events: none;
      font-size: 0.875rem !important;
      display: block;
    }

    ${required
      ? `
        & .vds-input-label::after {
          content: ' *';
        }
      `
      : ''}
    &.vds-input-textarea-container {
      min-width: auto; /* fixes min-width issue for multiline with width prop */
      margin-top: 0px;

      & .vds-input--textarea {
        pointer-events: auto;
      }
    }

    &.vds-input-textarea-container .vds-input-label:not(.vds-state--disabled),
    &.vds-input label.vds-input-label:not(.vds-state--disabled),
    &.vds-input.vds-state--filled:not(.vds-state--disabled) label.vds-input-label:first-of-type,
    &.vds-input-textarea-container.vds-state--filled:not(.vds-state--disabled),
    
      label.vds-input-label:first-of-type {
      font-size: 0.875rem;
      pointer-events: none;
      top: 0;
      position: relative;
      display: block;
      color:  ${vds?.miscExtraDark ?? '#000000'};;
    }

    /* Label color - Error */
    &.vds-input-textarea-container.vds-state--error
      label.vds-input-label:first-of-type,
    &.vds-input.vds-state--error label.vds-input-label:first-of-type,
    &.vds-input.vds-state--error.vds-state--focus label.vds-input-label:first-of-type,
    &.vds-input.vds-state--error.vds-state--filled label.vds-input-label:first-of-type {
      color: ${cybs?.base?.wcag21?.romaRed ?? '#B3202A'} !important;
    }

    /*
    * error state outline should be red
    */
    &.vds-input.vds-state--error.vds-state--focus,
    &.vds-input-textarea-container.vds-state--error.vds-state--focus {
      .vds-input-bar{
        outline: 1px dashed ${cybs?.base?.wcag21?.romaRed ?? '#B3202A'} !important;
        outline-offset:1px;
      }
    }


    &&.vds-input-textarea-container.vds-state--error > span,
    &&.vds-input-textarea-container .vds-input-count,
    &&.vds-input.vds-state--error > span {
      & > svg {
        vertical-align: top;
        top: 0;
      }
    }

    & .vds-input--input-text {
      box-shadow: none;
      padding: 0.375rem 0.25rem 0.375rem 0.25rem;
      height: 2rem;
    }

    /* Align icon and text in error message */
    &&.vds-input.vds-state--error .vds-input-message,
    &&.vds-input.vds-state--error.vds-state--filled .vds-input-message {
      display: flex;
    }

    && .vds-input-message {
      margin-top: 0px;
      position: static;
      color: ${vds?.primaryExtraDark2 ?? '#021E4C'};
      
    }

    /* Hide the clear button when this component is not focused */
    &:not(:focus-within)
      button[data-test='close-button-input-cybsButton-icon'] {
      display: none;
    }

    /*
    * ture blue color when the input is hovered focused and focused within
    * outline dashed border overall
    */
  
    &:focus-within,
    &.vds-input.vds-state--focus:not(.vds-state--readonly),
    &.vds-input.vds-state--focus:not(.vds-state--disabled),
    &.vds-input.vds-state--focus:not(.vds-state--error),
    &.vds-input.vds-state--focus.vds-state--filled,
    &.vds-input-textarea-container.vds-state--focus:not(.vds-state--disabled),
    &.vds-input-textarea-container.vds-state--focus:not(.vds-state--readonly),
    &.vds-input-textarea-container.vds-state--focus:not(.vds-state--error)
     {
      div.vds-input-bar {
      color: ${cybs?.core?.primary ?? '#1434CB'};
      outline: 1px dashed ${cybs?.core?.primary ?? '#1434CB'};
      outline-offset: 1px;
      border-color: ${cybs?.core?.primary ?? '#1434CB'};

        &::before {
          border-bottom: 1px solid ${cybs?.core?.primary ?? '#1434CB'} !important;
        }
      }
    }

    /*
    * Hover on textfield and textArea
    */
    &.vds-input:not(.vds-state--disabled):not(.vds-state--readonly):hover,
    &.vds-input-textarea-container:hover {
      label.vds-input-label:first-of-type {
        color: ${vds?.miscExtraDark ?? '#000000'};
      }
      & .vds-input-bar,
      & .vds-input-bar::before {
        border-color: ${cybs?.core?.primary ?? '#1434CB'};
      }
    }

    & .vds-input-bar:focus-within {
      outline-offset: 1px;
      outline: 1px dashed !important;
      outline-color: ${cybs?.core?.primary ?? '#1434CB'} !important;
    }
  `
});